Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.Comparator = {

    EQUAL: { value: 'EQUALS', label: 'Operators.eq' },
    NOT_EQUAL: { value: 'NOT_EQUALS', label: 'Operators.ne' },
    LESS_THAN: { value: 'LESS', label: 'Operators.lt' },
    EQUAL_OR_LESS_THAN: { value: 'LESS_OR_EQUALS', label: 'Operators.lte' },
    GREATER_THAN: { value: 'GREATER', label: 'Operators.gt' },
    EQUAL_OR_GREATER_THAN: { value: 'GREATER_OR_EQUALS', label: 'Operators.gte' },
    IN: { value: 'IN', label: 'Operators.in' },
    NOT_IN: { value: 'NOT_IN', label: 'Operators.notIn' },
    CONTAINS: { value: 'ANYWHERE', label: 'Operators.contains' },
    NOT_CONTAINS: { value: 'NOT_CONTAINS', label: 'Operators.notContains' },
    START: { value: 'STARTS_WITH', label: 'Operators.start' },
    END: { value: 'ENDS_WITH', label: 'Operators.end' }

};

Greenmile.PanelBuilder.Comparator.Fields = {

    INTEGER: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN
    ],

    DECIMAL: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN
    ],

    DISTANCE: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN
    ],

    LOOKUP: [Greenmile.PanelBuilder.Comparator.IN,
        Greenmile.PanelBuilder.Comparator.NOT_IN],

    POWER_LOOKUP_LIST_FILTER: [Greenmile.PanelBuilder.Comparator.IN,
        Greenmile.PanelBuilder.Comparator.NOT_IN],

    PICKLIST: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL],

    CHECKBOX: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL
    ],

    TEXT: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.CONTAINS,
        Greenmile.PanelBuilder.Comparator.NOT_CONTAINS,
        Greenmile.PanelBuilder.Comparator.START,
        Greenmile.PanelBuilder.Comparator.END
    ],

    DATE: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL],

    DATE_TIME: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN],

    SECONDS: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN
    ],

    TIME_MINUTES_SECONDS: [Greenmile.PanelBuilder.Comparator.EQUAL,
        Greenmile.PanelBuilder.Comparator.NOT_EQUAL,
        Greenmile.PanelBuilder.Comparator.GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_GREATER_THAN,
        Greenmile.PanelBuilder.Comparator.LESS_THAN,
        Greenmile.PanelBuilder.Comparator.EQUAL_OR_LESS_THAN
    ]

};

